module.exports = __webpack_public_path__ + "static/media/checklist.c649218d.jpg";